import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import DeleteRevitParameterTemplate from "./DeleteRevitParameterTemplate.graphql";

export default function useDeleteRevitParameterTemplate(id: string, __typename: string) {
    return useMutation(
        gql(DeleteRevitParameterTemplate),
        {
            update(cache) {
                // __typename is the concrete template type, not the IRevitParameterTemplate interface
                cache.evict({ id: cache.identify({ __typename, id }) });
                cache.gc();
            },
            variables: {
                id,
            },
        },
    );
}
